// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__9Avil","title":"AfterBackImages_title__1EJAA","images":"AfterBackImages_images__3ry3_"};